<script lang="ts">
  import { t } from '$lib/i18n/index.svelte';
  import { defang } from '$lib/protocol/link-guard';
  import type { QuestionElement } from '$lib/protocol/types';

  import type { ElementContext } from './context';

  let { element, ctx }: { element: QuestionElement; ctx: ElementContext } = $props();

  let text = $state('');

  const answered = $derived(ctx.answeredQuestions.has(element.questionId));
  const interactive = $derived(!answered && !ctx.disabled);

  function submit(value: string): void {
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return;
    }
    ctx.onAnswer(element.questionId, trimmed);
    text = '';
  }
</script>

<div class="question" class:answered>
  <p class="q">{defang(element.text)}</p>
  {#if interactive}
    {#if element.suggestions.length > 0}
      <div class="chips">
        {#each element.suggestions.slice(0, 8) as suggestion (suggestion)}
          <button class="chip" onclick={() => submit(suggestion)}>{defang(suggestion)}</button>
        {/each}
      </div>
    {/if}
    <div class="free">
      <input
        placeholder={t('el.question.answerHint')}
        bind:value={text}
        onkeydown={(event) => {
          if (event.key === 'Enter') {
            submit(text);
          }
        }}
      />
      <button class="send" disabled={text.trim().length === 0} onclick={() => submit(text)}>→</button>
    </div>
    {#if element.isRequired}
      <p class="required">{t('el.question.required')}</p>
    {/if}
  {/if}
</div>

<style>
  .question {
    border-left: 3px solid var(--brand);
    padding-left: 10px;
  }
  .answered {
    opacity: 0.75;
  }
  .q {
    margin: 0 0 8px;
    font-weight: 600;
    white-space: pre-wrap;
  }
  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 8px;
  }
  .chip {
    border: 1px solid var(--brand);
    background: transparent;
    color: var(--brand);
    border-radius: 999px;
    padding: 6px 14px;
    cursor: pointer;
    font-size: 14px;
  }
  .chip:hover {
    background: var(--bubble-mine);
  }
  .free {
    display: flex;
    gap: 6px;
  }
  input {
    flex: 1;
    border: 1px solid var(--line);
    border-radius: 8px;
    padding: 8px 10px;
    font: inherit;
    background: var(--surface);
    color: var(--ink);
  }
  .send {
    border: 0;
    border-radius: 8px;
    background: var(--brand);
    color: var(--brand-ink);
    padding: 0 14px;
    cursor: pointer;
  }
  .send:disabled {
    opacity: 0.4;
  }
  .required {
    margin: 6px 0 0;
    font-size: 12px;
    color: var(--warn-ink);
  }
</style>
